import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class RoiCalculatorService {
  yearlyRevenueControl = new FormControl(100000);
  monthlyInvoiceControl = new FormControl(100000);
}
